// extracted by mini-css-extract-plugin
export var fancyLink = "fancy-link-module--fancyLink--440f2";